import mieszkanie1 from '../../files/images/photosPage/Mieszkanie kolejowa/mieszkanie1.jpg'
import mieszkanie2 from '../../files/images/photosPage/Mieszkanie kolejowa/mieszkanie2.jpg'
import mieszkanie3 from '../../files/images/photosPage/Mieszkanie kolejowa/mieszkanie3.jpg'
import mieszkanie4 from '../../files/images/photosPage/Mieszkanie kolejowa/mieszkanie4.jpg'
import mieszkanie5 from '../../files/images/photosPage/Mieszkanie kolejowa/mieszkanie5.jpg'
import mieszkanie7 from '../../files/images/photosPage/Mieszkanie Robotnicza/mieszkanie7.jpg'
import mieszkanie6 from '../../files/images/photosPage/Mieszkanie Robotnicza/mieszkanie6.jpg'
import mieszkanie8 from '../../files/images/photosPage/Mieszkanie Robotnicza/mieszkanie8.jpg'
import mieszkanie9 from '../../files/images/photosPage/Mieszkanie Robotnicza/mieszkanie9.jpg'
import mieszkanie10 from '../../files/images/photosPage/Mieszkanie Robotnicza/mieszkanie10.jpg'

const imagesSlider4 = [
    { image: mieszkanie1, title: 'Salon z kanapą'},
    { image: mieszkanie2, title: 'Salon z meblami'},
    { image: mieszkanie3, title: 'Kuchnia'},
    { image: mieszkanie4, title: 'Przedpokój'},
    { image: mieszkanie5, title: 'Łazienka z prysznicem'},
    { image: mieszkanie6, title: 'Salon z kanapą'},
    { image: mieszkanie7, title: 'Kuchnia'},
    { image: mieszkanie8, title: 'Sypialnia z łóżkiem'},
    { image: mieszkanie9, title: 'Przedpokój'},
    { image: mieszkanie10, title: 'Łazienka '},  
  ];
  
  export default imagesSlider4;